<template>
  <section v-if="data">
    <PagesPressComponent :data="data" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
useHead({
  htmlAttrs: { 'data-page-type': 'press' }
})

const i18nActiveIso = baseI18nGetActiveIso()

const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryPressPage( i18nActiveIso ) )
)

basePageSetHead(data)
</script>
